import { render, staticRenderFns } from "./CoverageDetailFileTransfert.vue?vue&type=template&id=28d31f30"
import script from "./CoverageDetailFileTransfert.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverageDetailFileTransfert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports